import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const MenuEspecificoService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				usuario: filtro.usuario || null,
				tipo_usuario: filtro.tipo_usuario || null,
				modulo: filtro.modulo || null,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : null,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Menu_Especifico_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_acceso_menu_especifico: form.id_acceso_menu_especifico,
			id_usuario: form.id_usuario,
			id_cat_tipo_usuario: form.id_cat_tipo_usuario,
			id_menu: form.id_menu,
			activo: form.activo ? 1 : 0,
			empresas_seleccionadas: form.empresas_seleccionadas
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Menu_Especifico_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_acceso_menu_especifico: form.id_acceso_menu_especifico,
			id_usuario: form.id_usuario,
			id_cat_tipo_usuario: form.id_cat_tipo_usuario,
			id_menu: form.id_menu,
			activo: form.activo ? 1 : 0,
			empresas_seleccionadas: form.empresas_seleccionadas
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Menu_Especifico_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_acceso_menu_especifico) => {
		let params = {
			id_acceso_menu_especifico: id_acceso_menu_especifico
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Menu_Especifico_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
